import React, {useContext} from 'react';
import {useMediaQuery} from "react-responsive";
import selectors from '@state/selectors';
import { useSelector } from 'react-redux';
import {IProps} from './types';
import * as S from './styles';
import Search from '../Search';
import FoldersSearch from '../FoldersSearch';
import Filter from '../Filter';
import Chips from '@components/Chips';
import MoreChips from '../../../Templates/components/ListTemplate/components/MoreChips';
import Order from '../Order';
import { DesignsContext } from '@utils/DOIgnition/DesignsContext';

const Header:React.FC<IProps> = (props) => {
  const{ cleanFilters, allFilters, handleRemoveFilterChip } = useContext(DesignsContext);

  const smallDesktopScreen = useMediaQuery({ query: '(max-width: 1300px)' });
  const mediumDesktopScreen = useMediaQuery({ query: '(max-width: 1450px)' });

  const openMenu = useSelector(selectors.open.getOpenMenu);

  const countChips=()=>{
    let nchips=4;
    if(!openMenu)nchips=2;
    if(smallDesktopScreen){
        if(openMenu)nchips=2;
        else nchips=0;
    }
    else if(mediumDesktopScreen){
        if(openMenu)nchips=3;
        else nchips=1;
    }
    return nchips;
  }

  const handleRemoveAllChips = () => cleanFilters();

  const nchips=countChips();
  
  return (
    <S.Root>
      <S.ColRight>
        <Search/>
        {!props.hideFoldersSearch && <FoldersSearch/>}
        <Filter/>
      </S.ColRight>
      <S.ChipsCol>
        {allFilters && 
        <S.ChipsCol>
          <Chips items={allFilters.slice(0, nchips)} handleRemove={handleRemoveFilterChip}/>
        </S.ChipsCol>}
        {(allFilters?.length>nchips) && <MoreChips chips={allFilters.slice(nchips, allFilters.length)} handleRemove={handleRemoveFilterChip} handleRemoveAlll={handleRemoveAllChips} nchips={nchips}/>}
      </S.ChipsCol>
      <Order/>
    </S.Root>
  );
}

export default Header;